import { DepositDetailsType } from "app/types/cryptoType";
import { UserType } from "app/types/userType";
import { Component, MouseEventHandler } from "react";
import ReactTooltip from "react-tooltip";
import CryptoFundingDepositFailed from "./components/CryptoFundingDepositFailed/CryptoFundingDepositFailed";
import CryptoFundingDepositNew from "./components/CryptoFundingDepositNew/CryptoFundingDepositNew";
import CryptoFundingDepositPending from "./components/CryptoFundingDepositPending/CryptoFundingDepositPending";
import CryptoFundingDepositSuccess from "./components/CryptoFundingDepositSuccess/CryptoFundingDepositSuccess";
import CryptoFundingQuote from "./components/CryptoFundingQuote/CryptoFundingQuote";
import "./CryptoFundingCompleteDeposit.scss";

type Props = {
  depositDetails: DepositDetailsType;
  completeQuote: MouseEventHandler;
  cancelDeposit: MouseEventHandler;
  user: UserType;
  currency: string;
  backToHomepage: MouseEventHandler;
  copyAmountInfo: MouseEventHandler;
  copyWalletAddress: MouseEventHandler;
  txHash: string;
};

class CryptoFundingCompleteDeposit extends Component<Props> {
  componentDidUpdate() {
    // Tooltip needs to be rebuilt on state change to keep the click/mouseout events
    ReactTooltip.rebuild();
  }

  render() {
    const {
      depositDetails,
      completeQuote,
      cancelDeposit,
      user,
      currency,
      backToHomepage,
      copyAmountInfo,
      copyWalletAddress,
    } = this.props;

    return (
      <div className="crypto-funding-deposit-complete-deposit">
        {/* Once user has confirmed the deposit, dont show the quote anymore */}
        {!depositDetails.confirmed && (
          <CryptoFundingQuote
            depositDetails={depositDetails}
            user={user}
            copyAmountInfo={copyAmountInfo}
          />
        )}
        {/* Show this after quote is requested, but
        before user has confirmed the deposit.
        This shows the Wallet Address, Confirm Deposit button etc  */}
        {!depositDetails.confirmed && depositDetails.status === "NEW" && (
          <CryptoFundingDepositNew
            depositDetails={depositDetails}
            completeQuote={completeQuote}
            cancelDeposit={cancelDeposit}
            copyWalletAddress={copyWalletAddress}
          />
        )}
        {/* Show when user has Confirmed Deposit. */}
        {depositDetails.confirmed && depositDetails.status === "NEW" && (
          <CryptoFundingDepositPending
            currency={currency}
            depositDetails={depositDetails}
            cancelDeposit={cancelDeposit}
            user={user}
            backToHomepage={backToHomepage}
          />
        )}
        {depositDetails.status === "SUCCESS" && (
          <CryptoFundingDepositSuccess
            currency={currency}
            depositDetails={depositDetails}
            cancelDeposit={cancelDeposit}
            user={user}
            backToHomepage={backToHomepage}
          />
        )}
        {(depositDetails.status === "REJECT" ||
          depositDetails.status === "ERROR") && (
          <CryptoFundingDepositFailed
            currency={currency}
            depositDetails={depositDetails}
            user={user}
            cancelDeposit={cancelDeposit}
          />
        )}
      </div>
    );
  }
}

export default CryptoFundingCompleteDeposit;
